webpackJsonp([114276838955818,60335399758886],{

/***/ 102:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(202);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(102);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(306);
	var isArguments = __webpack_require__(305);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 305:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 306:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(450);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(304);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(432);
	
	var _HelmetConstants = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(313);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(469);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Arrow (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"Artboard","transform":"translate(-1241.000000, -19.000000)","fillRule":"nonzero","fill":"#FFFFFF"},React.createElement("g",{"id":"Group-9"},React.createElement("polygon",{"id":"arrow","points":"1241.55452 29.5545227 1242.44548 30.4454773 1247.89095 25 1242.44548 19.5545227 1241.55452 20.4454773 1246.10905 25"}))))]);
	}
	
	Arrow.displayName = "Arrow";
	
	Arrow.defaultProps = {"width":"7px","height":"12px","viewBox":"0 0 7 12","version":"1.1"};
	
	module.exports = Arrow;
	
	Arrow.default = Arrow;


/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function GrapheneLogo (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"graphene-logo"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"Artboard","transform":"translate(-140.000000, -12.000000)","fill":"#FFFFFF"},React.createElement("g",{"id":"Group-9"},React.createElement("g",{"id":"graphene-logo","transform":"translate(140.000000, 12.000000)"},[React.createElement("path",{"d":"M30.794,14.292 L30.794,9.756 C30.794,9.144 30.947,8.67900009 31.253,8.361 C31.559,8.04299991 32.108,7.884 32.9,7.884 C33.4880001,7.884 34.0579999,7.90799991 34.61,7.956 C35.1620001,8.00400009 35.7139999,8.08799991 36.266,8.208 L36.518,6.228 C35.978,6.084 35.393,5.98199991 34.763,5.922 C34.133,5.86200009 33.5719999,5.832 33.08,5.832 C31.5080001,5.832 30.3560001,6.12599991 29.624,6.714 C28.8919999,7.30200009 28.526,8.21399991 28.526,9.45 L28.526,14.562 C28.526,15.7620001 28.8800001,16.6649999 29.588,17.271 C30.2959999,17.8770001 31.388,18.18 32.864,18.18 C33.4999999,18.18 34.169,18.135 34.871,18.045 C35.573,17.955 36.2420001,17.82 36.878,17.64 L36.878,12.366 L34.736,12.366 L34.736,16.002 C34.4240001,16.0500001 34.115,16.0860001 33.809,16.11 C33.503,16.1339999 33.1939999,16.146 32.882,16.146 C32.09,16.146 31.5440001,15.984 31.244,15.66 C30.9439999,15.336 30.794,14.8800001 30.794,14.292 Z M43.736,11.07 L43.52,9.054 C43.3279999,9.11399991 43.1209999,9.19200009 42.899,9.288 C42.6770001,9.38399991 42.4639999,9.486 42.26,9.594 C42.0560001,9.702 41.8609999,9.81 41.675,9.918 C41.4890001,10.026 41.3360001,10.1219999 41.216,10.206 L41.072,9.234 L39.218,9.234 L39.218,18 L41.414,18 L41.414,12.348 C41.81,12.096 42.1910001,11.8679999 42.557,11.664 C42.9229999,11.4600001 43.3160001,11.2620001 43.736,11.07 Z M51.944,18 L50.126,18 L49.982,17.388 C49.6099999,17.6279999 49.172,17.82 48.668,17.964 C48.164,18.108 47.66,18.18 47.156,18.18 C46.724,18.18 46.3609999,18.1110001 46.067,17.973 C45.7730001,17.8349999 45.5300001,17.6430001 45.338,17.397 C45.1459999,17.1509999 45.0080001,16.866 44.924,16.542 C44.8399999,16.218 44.798,15.8639999 44.798,15.48 C44.798,14.5920001 45.005,13.9440001 45.419,13.536 C45.833,13.1279999 46.5020001,12.924 47.426,12.924 L49.748,12.924 L49.748,12.186 C49.748,11.7419999 49.6430001,11.412 49.433,11.196 C49.2229999,10.98 48.7999999,10.872 48.164,10.872 C47.7800001,10.872 47.3750001,10.9110001 46.949,10.989 C46.5229999,11.0669999 46.1359999,11.1659999 45.788,11.286 L45.482,9.522 C45.6740001,9.45 45.8929999,9.38399991 46.139,9.324 C46.3850001,9.26400009 46.643,9.21299991 46.913,9.171 C47.183,9.12900009 47.4499999,9.099 47.714,9.081 C47.9780001,9.063 48.2239999,9.054 48.452,9.054 C49.1120001,9.054 49.667,9.11100009 50.117,9.225 C50.567,9.33899991 50.927,9.522 51.197,9.774 C51.467,10.026 51.6590001,10.35 51.773,10.746 C51.8869999,11.142 51.944,11.6159999 51.944,12.168 L51.944,18 Z M49.748,14.508 L47.912,14.508 C47.552,14.508 47.2969999,14.5740001 47.147,14.706 C46.9970001,14.8379999 46.922,15.0899999 46.922,15.462 C46.922,15.7980001 46.9880001,16.0619999 47.12,16.254 C47.2519999,16.4460001 47.5039999,16.542 47.876,16.542 C48.2480001,16.542 48.605,16.497 48.947,16.407 C49.289,16.317 49.5559999,16.2239999 49.748,16.128 L49.748,14.508 Z M61.718,15.084 C61.718,16.056 61.4899999,16.8150001 61.034,17.361 C60.5780001,17.9069999 59.8400001,18.18 58.82,18.18 C58.4360001,18.18 58.037,18.1560001 57.623,18.108 C57.209,18.0599999 56.8279999,18 56.48,17.928 L56.48,21.546 L54.284,21.852 L54.284,9.234 L56.03,9.234 L56.246,9.972 C56.6299999,9.69600009 57.0500001,9.47399991 57.506,9.306 C57.9619999,9.13800009 58.4659999,9.054 59.018,9.054 C59.9059999,9.054 60.5780001,9.30900009 61.034,9.819 C61.4899999,10.3289999 61.718,11.088 61.718,12.096 L61.718,15.084 Z M56.48,16.074 C56.768,16.1339999 57.0860001,16.1879999 57.434,16.236 C57.7819999,16.2840001 58.1120001,16.308 58.424,16.308 C58.82,16.308 59.1020001,16.2120001 59.27,16.02 C59.4379999,15.8279999 59.522,15.534 59.522,15.138 L59.522,12.042 C59.522,11.682 59.4440001,11.4060001 59.288,11.214 C59.1319999,11.0219999 58.8500001,10.926 58.442,10.926 C58.082,10.926 57.7250001,11.0039999 57.371,11.16 C57.0169999,11.3160001 56.7199999,11.502 56.48,11.718 L56.48,16.074 Z M69.062,18 L71.258,18 L71.258,11.646 C71.258,10.854 71.1109999,10.224 70.817,9.756 C70.5230001,9.288 70.0100001,9.054 69.278,9.054 C68.81,9.054 68.2820001,9.13199991 67.694,9.288 C67.1059999,9.44400009 66.5659999,9.648 66.074,9.9 L66.074,5.346 L63.878,5.652 L63.878,18 L66.074,18 L66.074,11.916 C66.47,11.7120001 66.8809999,11.538 67.307,11.394 C67.7330001,11.25 68.0840001,11.178 68.36,11.178 C68.612,11.178 68.792,11.2350001 68.9,11.349 C69.008,11.4629999 69.062,11.6400001 69.062,11.88 L69.062,18 Z M75.488,14.922 C75.488,15.462 75.605,15.8430001 75.839,16.065 C76.073,16.2869999 76.5260001,16.398 77.198,16.398 C77.702,16.398 78.2000001,16.3560001 78.692,16.272 C79.1839999,16.1879999 79.5860001,16.092 79.898,15.984 L80.222,17.658 C80.0180001,17.7420001 79.7840001,17.8169999 79.52,17.883 C79.2559999,17.9490001 78.98,18.0030001 78.692,18.045 C78.404,18.0869999 78.116,18.1200001 77.828,18.144 C77.54,18.1679999 77.2640001,18.18 77,18.18 C76.316,18.18 75.7369999,18.1020001 75.263,17.946 C74.7890001,17.7899999 74.4049999,17.568 74.111,17.28 C73.8170001,16.992 73.607,16.6379999 73.481,16.218 C73.355,15.7980001 73.292,15.3239999 73.292,14.796 L73.292,12.474 C73.292,12.006 73.3490001,11.565 73.463,11.151 C73.5769999,10.737 73.7749999,10.3739999 74.057,10.062 C74.3390001,9.75000009 74.7109999,9.504 75.173,9.324 C75.6350001,9.144 76.2200001,9.054 76.928,9.054 C77.6240001,9.054 78.197,9.14999991 78.647,9.342 C79.097,9.53400009 79.448,9.792 79.7,10.116 C79.952,10.44 80.1260001,10.8149999 80.222,11.241 C80.3179999,11.6670001 80.366,12.114 80.366,12.582 L80.366,14.544 L75.488,14.544 L75.488,14.922 Z M75.488,12.87 L78.278,12.87 L78.278,12.15 C78.278,11.7419999 78.1820001,11.4060001 77.99,11.142 C77.7979999,10.8779999 77.4379999,10.746 76.91,10.746 C76.37,10.746 75.9979999,10.8750001 75.794,11.133 C75.5900001,11.3909999 75.488,11.7300001 75.488,12.15 L75.488,12.87 Z M87.53,18 L89.726,18 L89.726,11.646 C89.726,10.854 89.5789999,10.224 89.285,9.756 C88.9910001,9.288 88.4780001,9.054 87.746,9.054 C87.2299999,9.054 86.6539999,9.13800009 86.018,9.306 C85.3820001,9.47399991 84.7880001,9.69600009 84.236,9.972 L84.02,9.234 L82.346,9.234 L82.346,18 L84.542,18 L84.542,11.916 C84.938,11.7120001 85.3489999,11.538 85.775,11.394 C86.2010001,11.25 86.5520001,11.178 86.828,11.178 C87.08,11.178 87.26,11.2350001 87.368,11.349 C87.476,11.4629999 87.53,11.6400001 87.53,11.88 L87.53,18 Z M93.956,14.922 C93.956,15.462 94.073,15.8430001 94.307,16.065 C94.541,16.2869999 94.9940001,16.398 95.666,16.398 C96.17,16.398 96.6680001,16.3560001 97.16,16.272 C97.6519999,16.1879999 98.0540001,16.092 98.366,15.984 L98.69,17.658 C98.4860001,17.7420001 98.2520001,17.8169999 97.988,17.883 C97.7239999,17.9490001 97.448,18.0030001 97.16,18.045 C96.872,18.0869999 96.584,18.1200001 96.296,18.144 C96.008,18.1679999 95.7320001,18.18 95.468,18.18 C94.784,18.18 94.2049999,18.1020001 93.731,17.946 C93.2570001,17.7899999 92.8729999,17.568 92.579,17.28 C92.2850001,16.992 92.075,16.6379999 91.949,16.218 C91.823,15.7980001 91.76,15.3239999 91.76,14.796 L91.76,12.474 C91.76,12.006 91.8170001,11.565 91.931,11.151 C92.0449999,10.737 92.2429999,10.3739999 92.525,10.062 C92.8070001,9.75000009 93.1789999,9.504 93.641,9.324 C94.1030001,9.144 94.6880001,9.054 95.396,9.054 C96.0920001,9.054 96.665,9.14999991 97.115,9.342 C97.565,9.53400009 97.916,9.792 98.168,10.116 C98.42,10.44 98.5940001,10.8149999 98.69,11.241 C98.7859999,11.6670001 98.834,12.114 98.834,12.582 L98.834,14.544 L93.956,14.544 L93.956,14.922 Z M93.956,12.87 L96.746,12.87 L96.746,12.15 C96.746,11.7419999 96.6500001,11.4060001 96.458,11.142 C96.2659999,10.8779999 95.9059999,10.746 95.378,10.746 C94.838,10.746 94.4659999,10.8750001 94.262,11.133 C94.0580001,11.3909999 93.956,11.7300001 93.956,12.15 L93.956,12.87 Z","id":"Graphene","key":0}),React.createElement("g",{"id":"Group-16","key":1},React.createElement("polygon",{"id":"Combined-Shape","points":"10.5 14.3528646 10.5 14.3903346 8.67673125 13.3059059 8.67673125 11.2269905 8.61538462 11.1893476 19.1532465 5.00262926 20.9942908 6.01446585 21 6.01115242 21 6.01760363 21.0027186 6.01909779 21 6.02070989 21 18.3598477 10.5 24.4479648 10.5 24.5 10.4555027 24.4737653 10.4102564 24.5 10.411937 24.4480798 2.22044605e-16 18.3094065 2.22044605e-16 6.10223048 0.0452529102 6.12523832 0.00787599784 6.10240209 10.4088305 -8.8817842e-16 12.2051282 1.04723909 12.1821653 1.06080222 12.2948718 3.11842566 3.59230214 8.19765963 3.59230214 16.2482445 3.6022151 16.2424894 10.4026795 20.1700092 17.3205128 16.1969799 17.3205128 10.3938645 10.5 14.3528646"}))]))))]);
	}
	
	GrapheneLogo.displayName = "GrapheneLogo";
	
	GrapheneLogo.defaultProps = {"width":"99px","height":"25px","viewBox":"0 0 99 25","version":"1.1"};
	
	module.exports = GrapheneLogo;
	
	GrapheneLogo.default = GrapheneLogo;


/***/ }),

/***/ 314:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(43);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(431);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _grapheneLogo = __webpack_require__(473);
	
	var _grapheneLogo2 = _interopRequireDefault(_grapheneLogo);
	
	var _arrow = __webpack_require__(472);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	var _logoOnWhite = __webpack_require__(474);
	
	var _logoOnWhite2 = _interopRequireDefault(_logoOnWhite);
	
	__webpack_require__(314);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    "div",
	    {
	      "data-jsx": 508597432
	    },
	    _react2.default.createElement(
	      "header",
	      { className: "graphene-header", "data-jsx": 508597432
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "container", "data-jsx": 508597432
	        },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/" },
	          _react2.default.createElement(_grapheneLogo2.default, { className: "graphene-logo" })
	        ),
	        _react2.default.createElement(
	          "a",
	          { className: "tagline", href: "//graphene.tools/", "data-jsx": 508597432
	          },
	          "Learn how Quiver fits into the ",
	          _react2.default.createElement(
	            "b",
	            {
	              "data-jsx": 508597432
	            },
	            "Graphene family"
	          ),
	          _react2.default.createElement(_arrow2.default, { className: "arrow" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "header",
	      { className: "container navbar-header", "data-jsx": 508597432
	      },
	      _react2.default.createElement(
	        "a",
	        { href: "/", className: "logo-link", "data-jsx": 508597432
	        },
	        _react2.default.createElement(_logoOnWhite2.default, null)
	      ),
	      _react2.default.createElement(
	        "nav",
	        {
	          "data-jsx": 508597432
	        },
	        _react2.default.createElement(
	          "a",
	          { href: "/pricing", "data-jsx": 508597432
	          },
	          "Pricing"
	        ),
	        _react2.default.createElement(
	          "a",
	          { href: "/signup", "data-jsx": 508597432
	          },
	          "Signup"
	        ),
	        _react2.default.createElement(
	          "a",
	          { href: "/benchmarks", "data-jsx": 508597432
	          },
	          "Benchmarks"
	        ),
	        _react2.default.createElement(
	          "a",
	          { href: "https://dashboard.graphql-quiver.com/", "data-jsx": 508597432
	          },
	          "Dashboard \u2192"
	        )
	      )
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: 508597432,
	      css: "@import url(\"https://fonts.googleapis.com/css?family=Fira+Mono|Open+Sans:400,600\");.logo-link[data-jsx=\"508597432\"]{height:61px}.graphene-header[data-jsx=\"508597432\"]{background:#000000;width:100%;font-family:\"klavika-web\";font-weight:300;font-size:18px;color:#ffffff;-webkit-letter-spacing:0;-moz-letter-spacing:0;-ms-letter-spacing:0;letter-spacing:0}.graphene-logo{vertical-align:middle}.graphene-header[data-jsx=\"508597432\"] .container[data-jsx=\"508597432\"]{height:48px;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.tagline[data-jsx=\"508597432\"]{margin-left:auto;color:#a4b1b2;font-size:14px;-webkit-letter-spacing:0;-moz-letter-spacing:0;-ms-letter-spacing:0;letter-spacing:0;margin-bottom:0;margin-top:0;text-transform:none}.tagline[data-jsx=\"508597432\"] b[data-jsx=\"508597432\"]{font-weight:400;-webkit-letter-spacing:0.3px;-moz-letter-spacing:0.3px;-ms-letter-spacing:0.3px;letter-spacing:0.3px;color:white}svg.arrow{margin-left:8px;position:relative;top:2px}.navbar-header[data-jsx=\"508597432\"]{height:94px;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.navbar-header[data-jsx=\"508597432\"] nav[data-jsx=\"508597432\"]{height:100%;display:block;margin-left:auto}.navbar-header[data-jsx=\"508597432\"] nav[data-jsx=\"508597432\"] a[data-jsx=\"508597432\"]{height:100%;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#555555;font-size:14px;font-family:\"Open Sans\",sans-serif;font-weight:600;height:94px;line-height:94px;padding:0 10px;margin:0;text-decoration:none;font-weight:600}.navbar-header[data-jsx=\"508597432\"] nav[data-jsx=\"508597432\"] a[data-jsx=\"508597432\"]:hover{color:black}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/layouts/index.js */"
	    })
	  );
	};
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: "Graphene-Python",
	      meta: [{ name: "description", content: "Graphene framework for Python" }, { name: "keywords", content: "graphene, graphql, python, framework" }]
	    }),
	    _react2.default.createElement(Header, null),
	    _react2.default.createElement(
	      "div",
	      null,
	      children()
	    )
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports["default"];

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function LogoOnWhite (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"Artboard","transform":"translate(-140.000000, -71.000000)"},React.createElement("g",{"id":"Group","transform":"translate(140.000000, 71.000000)"},[React.createElement("g",{"id":"Group-5","key":0},[React.createElement("polygon",{"id":"Path-8","fill":"#1290A4","points":"47.4043439 47.5829393 42.9369084 44.9948394 42.9636007 20.1052657 25.9742121 10.2628774 25.9442736 5.10164231 47.3976918 17.5301573","key":0}),React.createElement("polygon",{"id":"Path-9","fill":"#2FBDAB","points":"47.4557294 47.4863335 51.8433244 44.9151459 51.9071717 14.9957098 47.3391541 17.5194785 47.3391541 42.2909311 26.073204 50.870426 25.8946039 59.9687609","key":1}),React.createElement("polygon",{"id":"Path-9","fill":"#2FBDAB","points":"4.55696086 47.351294 9.06113119 44.7814271 9.2789847 20.1213492 26.0054577 10.2782281 26.1567693 5.05400148 9.12497847 14.861991 4.55696086 17.3857598","key":2}),React.createElement("polygon",{"id":"Path-10","fill":"#72F3C2","points":"51.9701447 15.0084622 47.4522884 17.6268016 25.9904079 5.19338412 4.53235086 17.716303 0 15.090596 26.1314766 0.0394595586","key":3}),React.createElement("polygon",{"id":"Path-10","fill":"#72F3C2","points":"22.5535149 56.8541515 18.021164 54.2284444 42.9086259 39.8311027 47.317906 42.4355964","key":4}),React.createElement("polygon",{"id":"Path-9","fill":"#2FBDAB","points":"26.0421429 59.8356717 30.4297379 57.264484 30.4935852 27.3450479 25.9255676 29.8688167","key":5}),React.createElement("polygon",{"id":"Path-11","fill":"#72F3C2","points":"25.9425259 49.5882137 22.8641445 53.046565 4.6313933 42.483865 9.06174512 39.8087448","key":6}),React.createElement("polygon",{"id":"Path-8","fill":"#1290A4","points":"0.0818397623 14.9022558 4.54927528 17.4903557 4.52258297 42.3799295 21.5119715 52.2223177 21.5222601 27.3232408 25.9694297 29.8996002 25.9408454 59.9319688 0.0884918272 44.9550378","key":7}),React.createElement("polygon",{"id":"Path-12","fill":"#72F3C2","points":"30.4837006 27.3990199 25.9971915 24.7998702 21.5520282 27.3521816 25.9934931 29.9252361","key":8})]),React.createElement("path",{"d":"M78.693,42.828 C77.0803335,42.7186665 75.7136665,42.418 74.593,41.926 C73.4723335,41.434 72.5703335,40.819 71.887,40.081 C71.2036665,39.343 70.7116665,38.4956665 70.411,37.539 C70.1103335,36.5823335 69.96,35.571 69.96,34.505 L69.96,23.189 C69.96,22.041 70.1376665,20.9613335 70.493,19.95 C70.8483335,18.9386665 71.4291665,18.0503335 72.2355,17.285 C73.0418335,16.5196665 74.101,15.9115 75.413,15.4605 C76.725,15.0095 78.3513335,14.784 80.292,14.784 C82.2053335,14.784 83.8248335,15.0095 85.1505,15.4605 C86.4761665,15.9115 87.5421665,16.5196665 88.3485,17.285 C89.1548335,18.0503335 89.7356665,18.9386665 90.091,19.95 C90.4463335,20.9613335 90.624,22.041 90.624,23.189 L90.624,34.505 C90.624,35.4343335 90.5078335,36.3295 90.2755,37.1905 C90.0431665,38.0515 89.6673335,38.8305 89.148,39.5275 C88.6286665,40.2245 87.9453335,40.8326665 87.098,41.352 C86.2506665,41.8713335 85.2256665,42.2676665 84.023,42.541 L86.196,47.666 L81.563,49.593 L78.693,42.828 Z M75.126,34.218 C75.126,35.5026665 75.5018335,36.514 76.2535,37.252 C77.0051665,37.99 78.3513335,38.359 80.292,38.359 C82.2053335,38.359 83.5446665,37.99 84.31,37.252 C85.0753335,36.514 85.458,35.5026665 85.458,34.218 L85.458,23.476 C85.458,22.1913335 85.0753335,21.18 84.31,20.442 C83.5446665,19.704 82.2053335,19.335 80.292,19.335 C78.3513335,19.335 77.0051665,19.704 76.2535,20.442 C75.5018335,21.18 75.126,22.1913335 75.126,23.476 L75.126,34.218 Z M100.001,22.533 L94.999,22.533 L94.999,37.006 C94.999,38.81 95.3338335,40.245 96.0035,41.311 C96.6731665,42.377 97.8416665,42.91 99.509,42.91 C100.684334,42.91 101.996334,42.7186665 103.445,42.336 C104.893666,41.9533335 106.246666,41.4476665 107.504,40.819 L107.996,42.5 L111.809,42.5 L111.809,22.533 L106.807,22.533 L106.807,36.391 C105.905,36.8556665 104.968834,37.252 103.9985,37.58 C103.028166,37.908 102.228666,38.072 101.6,38.072 C101.026,38.072 100.616,37.9421665 100.37,37.6825 C100.124,37.4228335 100.001,37.0196665 100.001,36.473 L100.001,22.533 Z M116.799,42.5 L121.801,42.5 L121.801,22.533 L116.799,22.533 L116.799,42.5 Z M116.799,19.704 L121.801,19.704 L121.801,13.923 L116.799,13.923 L116.799,19.704 Z M137.123,42.5 L143.519,22.533 L138.394,22.533 L133.802,37.703 L129.251,22.533 L124.126,22.533 L130.522,42.5 L137.123,42.5 Z M149.944,35.489 C149.944,36.719 150.2105,37.5868335 150.7435,38.0925 C151.2765,38.5981665 152.308334,38.851 153.839,38.851 C154.987,38.851 156.121334,38.7553335 157.242,38.564 C158.362666,38.3726665 159.278334,38.154 159.989,37.908 L160.727,41.721 C160.262334,41.9123335 159.729334,42.0831665 159.128,42.2335 C158.526666,42.3838335 157.898,42.5068335 157.242,42.6025 C156.586,42.6981665 155.93,42.7733335 155.274,42.828 C154.618,42.8826665 153.989334,42.91 153.388,42.91 C151.83,42.91 150.511166,42.7323335 149.4315,42.377 C148.351834,42.0216665 147.477166,41.516 146.8075,40.86 C146.137834,40.204 145.6595,39.3976665 145.3725,38.441 C145.0855,37.4843335 144.942,36.4046665 144.942,35.202 L144.942,29.913 C144.942,28.847 145.071834,27.8425 145.3315,26.8995 C145.591166,25.9565 146.042166,25.1296665 146.6845,24.419 C147.326834,23.7083335 148.174166,23.148 149.2265,22.738 C150.278834,22.328 151.611334,22.123 153.224,22.123 C154.809334,22.123 156.1145,22.3416665 157.1395,22.779 C158.1645,23.2163335 158.964,23.804 159.538,24.542 C160.112,25.28 160.508334,26.1341665 160.727,27.1045 C160.945666,28.0748335 161.055,29.093 161.055,30.159 L161.055,34.628 L149.944,34.628 L149.944,35.489 Z M149.944,30.815 L156.299,30.815 L156.299,29.175 C156.299,28.2456665 156.080334,27.4803335 155.643,26.879 C155.205666,26.2776665 154.385666,25.977 153.183,25.977 C151.953,25.977 151.105666,26.2708335 150.641,26.8585 C150.176334,27.4461665 149.944,28.2183335 149.944,29.175 L149.944,30.815 Z M175.106,26.715 L174.614,22.123 C174.176666,22.2596665 173.705166,22.4373335 173.1995,22.656 C172.693834,22.8746665 172.208666,23.107 171.744,23.353 C171.279334,23.599 170.835166,23.845 170.4115,24.091 C169.987834,24.337 169.639334,24.5556665 169.366,24.747 L169.038,22.533 L164.815,22.533 L164.815,42.5 L169.817,42.5 L169.817,29.626 C170.719,29.052 171.586834,28.5326665 172.4205,28.068 C173.254166,27.6033335 174.149334,27.1523335 175.106,26.715 Z","id":"Quiver","fill":"#000000","key":1})])))]);
	}
	
	LogoOnWhite.displayName = "LogoOnWhite";
	
	LogoOnWhite.defaultProps = {"width":"176px","height":"60px","viewBox":"0 0 176 60","version":"1.1"};
	
	module.exports = LogoOnWhite;
	
	LogoOnWhite.default = LogoOnWhite;


/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-31942c875a58c6beb0a7.js